<template>
  <div class="videos-navigation">
    <div class="newcontrols">
      <button class="vcv-button button-prev wnew"
         v-if="!first && show_prev_btn"
         @click="$emit('prev');"
      >
        <span class="narrow prev"></span>
      </button>
      <button class="vcv-button button-next wnew"
         v-if="!last && show_next_btn"
         @click="$emit('next');"
      >
        <span>{{ $tr('videoInterview.checkVideo.nextQuestion') }} </span><span class="narrow"></span>
      </button>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'video_paginator',
    props: {
      last: Boolean,
      first: Boolean,
      show_prev_btn: {
        type: Boolean,
        default: true
      },
      show_next_btn: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.videos-navigation {
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;

  .emo {
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
      margin-left: 10px;
    }
  }

  .vcv-button {
    margin-left: 10px;
    &.wnew {
      display: flex;
      align-items: center;
      border-radius: 0;
      border-color: #d2d6e0;
      background: #fff;
      color: #232323;
      padding: 10px 20px;
      &:hover {
        background: #f4f5f7;
        border-color: #f4f5f7;
      }

      &:active {
        background: #fff;
        border-color: #437aee;
      }
      & span {
        padding-right: 15px;
        text-transform: initial;
      }
      .narrow {
        display: block;
        width: 14px;
        height: 14px;
        background: url('/static/icons/arrow.svg') center right no-repeat;
        padding-right: 0;
        &.prev {
          transform: rotate(-180deg);
        }
      }
    }
  }

  @media screen and (max-width: 1199px) {
    .vcv-button.next {
      width: 38px;
      padding: 0;
      span {
        display: none;
      }
    }
  }
}

.emo-block {
  position: relative;
}

.dropdown {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  bottom: 45px;
  background: $white-color;
  position: absolute;
  width: 450px;
  box-sizing: border-box;
  list-style-type: none;
  margin-top: 15px;

  .emotion {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    width: 42%;
    margin-bottom: 10px;
    user-select: none;
    cursor: default;

    &:nth-last-child(-n + 2) {
      margin-bottom: 0;
    }
  }

  .title {
    display: flex;
    align-items: center;
  }

  .icon {
    background-size: cover;
    width: 22px;
    height: 22px;
    object-fit: contain;
    margin-right: 10px;
  }

  .arrow {
    position: relative;
    width: 25px;
    height: 15px;
    transition: transform 0.5s;
  }

  .arrow_down {
    transform: rotate(180deg);
  }

  .arrow:after,
  .arrow:before {
    position: absolute;
    top: 5px;
    display: block;
    content: '';
    width: 15px;
    height: 2px;
    background-color: $green;
  }

  .arrow:after {
    left: 0;
    transform: rotate(-40deg);
  }

  .arrow:before {
    left: 10px;
    transform: rotate(40deg);
  }
}

.newcontrols {
  display: flex;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  .vcv-button {
    margin: 0;
    &.button-next {
      margin-left: auto;
    }
    &.button-prev {
      margin-right: auto;
      padding: 10px 12px;

      & + .button-next {
        margin-left: 10px;
      }
    }
  }
}
</style>
